import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import { CustomHttpClientService } from './custom-http-client.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class PaymentService {

  private url = environment.apiUrl;

  constructor(private http: CustomHttpClientService) { }

  /**
   * REST service call handler to the backed to pay for subscription by netbanking
   * @param publicToken
   * @param metadata
   * @param isPromoValid
   * @param buildingData
   * @returns {Observable<any>}
   */

  payByBanking(publicToken: string, metadata: any, isPromoValid: boolean, buildingData: any): Observable<any> {
    const accountData = {
      publicToken,
      data: metadata,
      isPromoValid,
      building: buildingData
    };

    const apiUri = `${this.url}plaid/pay`;
    
    return this.http.post(apiUri, { account: accountData }).pipe(
      map((response: any) => response) // Directly return response, no need for .json() in HttpClient
    );
  }

  /**
   * REST Service handler for pay subscription by card
   * @param formData
   * @returns {Observable<any>}
   */


  payByCard(formData: any): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl }auth/buildingManagerSignup`, formData).pipe(
      map(response => response) // Directly return response, no need for .json() in HttpClient
    );
  }

  /**
   * Get Stripe customer information by User ID
   * @param userId
   * @returns {Observable<any>}
   */
  getCustomer(userId: string): Observable<any> {
    return this.http.get<any>(`${this.url}stripe/customer/${userId}`).pipe(
      map(response => response) // Directly return response, no need for .json() in HttpClient
    );
  }
  /**
   * REST handler for saving a new credit card
   * @param token
   * @param customerId
   * @param card
   * @param allCards
   * @returns {Observable<any>}
   */
  saveNewCard(token: string, customerId: string, card: any, allCards: any[]): Observable<any> {
    return this.http.post<any>(`${this.url}stripe/card`, {
      token: token,
      card: card,
      customerId: customerId,
      cards: allCards
    }).pipe(
      map(response => response) // Directly return response, no need for .json() in HttpClient
    );
  }

  

  /**
   * REST handler for updating subscription by Credit Card
   * @param formData
   * @param userId
   * @returns {Observable<any>}
   */
  updateSubscriptionByCard(formData: FormData, userId: string): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}user/${userId}/building/mode/card`, formData).pipe(
      map(response => response) // Directly return the response
    );
  }

    /**
   * REST handler for updating subscription by Credit Card
   * @param formData
   * @param userId
   * @returns {Observable<any>}
   */


  getCost(formData: FormData, userId: string): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}user/${userId}/building/mode/cost`, formData).pipe(
      map(response => response) // Directly return the response
    );
  }

  /**
   * REST handler to save a bank account for net banking
   * @param token
   * @param accountId
   * @param metadata
   * @param userId
   * @returns {Observable<any>}
   */

  addBankAccount(token: string, accountId: string, metadata: any, userId: string): Observable<any> {
    return this.http.post<any>(`${this.url}stripe/bank`, {
      token,
      accountId,
      paymentData: metadata,
      customerId: userId
    }).pipe(
      map(response => response) // Directly return the response
    );
  }

  /**
   * REST handler for updating subscription by NetBanking
   * @param buildingData
   * @param userId
   * @returns {Observable<any>}
   */


  updateSubscriptionByBanking(buildingData: any, userId: string): Observable<any> {
    return this.http.post<any>(`${this.url}user/${userId}/building/mode/bank`, { buildingData })
      .pipe(
        map(response => response) // Directly return the response
      );
  }

  accountDowngrade(userId: string, buildingId: string | null = null): Observable<any> {
    return this.http.post<any>(`${this.url}stripe/accountDowngrade`, { userId, buildingId })
      .pipe(
        map(response => response) // Directly return the response
      );
  }

}
